<!-- Pagination Starts -->
<div class="d-flex align-items-center" *ngIf="(pager?.totalPages > 0)" >
 
  
      <ul class="pagination">
     
      
      <li class="page-item" [ngClass]="(pager.currentPage <= 1)?'disabled page-item':'page-item'">
        <a (click)="setPage(pager.currentPage - 1, pagerData.pagerSize)" class="page-link font-weight-bold d-flex align-items-center justify-content-center">
          <em class="fas fa-chevron-left fa-lg"></em> </a>
        </li>
      <li class="page-item" *ngFor="let page of pager.pages"  [ngClass]="{'active':pager.currentPage === page}">
        <a (click)="setPage(page, pagerData.pagerSize)" class="page-link font-weight-bold d-flex align-items-center justify-content-center">{{page}}</a>
      </li>
      <li class="page-item" [ngClass]="(pager?.totalPages <= pager?.currentPage)?'page-item disabled':'page-item'">
        <a (click)="setPage(pager.currentPage + 1, pagerData.pagerSize)" class="page-link font-weight-bold d-flex align-items-center justify-content-center">
          <em class="fas fa-chevron-right fa-lg"></em> </a>
        </li>
    </ul>
  
    
 
    <div class="mb-md-0 px-3">
      <div class="d-flex align-items-center justify-content-center"  >
        <div class="align-self-center"> {{"lblShow" | translate}}</div>
        <div class="px-2">
          
            <select class="font-weight-bold font-16 custom-select" (change)="setPage(1, pagerData.pagerSize)" [(ngModel)]="pagerData.pagerSize" #pagerData.pagerSize id="pagerSize" name="pagerSize">
              <option value="{{option}}" *ngFor="let option of options">{{option}}</option>
            </select>
          
        </div>
        <div class=""> {{"lblEntries" | translate}} </div>
      </div>
    </div>
    <div class="align-self-center mb-md-0 text-center mx-auto">
     <!-- {{ calcShowingCount() }} -->
    </div>
    
  </div>
  <!-- Pagination Ends -->
  